// *****
// Sitecore link types are: internal, external, anchor, media, mailto, javascript
// type mailto links already have the `mailto:` string prepended
// *****

import React from "react";
import { string, oneOf, bool, func, object } from "prop-types";
import cx from "classnames";

import Icon from "../Icon/Icon.jsx";

const propTypes = {
  href: string.isRequired,
  type: oneOf([
    "",
    "internal",
    "external",
    "anchor",
    "mailto",
    "media",
    "download",
    "arrow",
  ]),
  text: string,
  title: string,
  className: string,
  reversed: bool,
  onKeyDown: func,
  lang: string,
  gtmElementLabel: string,
  focusRef: object,
};

const ArrowLink = (props) => {
  const {
    href,
    type,
    text,
    title,
    className,
    lang,
    reversed = false,
    gtmElementLabel,
    focusRef,
  } = props;

  let download = false;
  let iconName = "";

  switch (type) {
    case "download":
    case "media":
      download = true;
      iconName = "download";
      break;
    case "external":
      iconName = "external";
      break;
    case "anchor":
    case "arrow":
      iconName = reversed ? "arrow-left" : "arrow-right";
      break;
    default:
  }

  const classModifier = type ? `arrow-link--${type}` : "";

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={href}
      hrefLang={lang || null}
      className={cx(`arrow-link ${classModifier} ${className || ""}`, {
        "arrow-link--reversed": reversed,
      })}
      title={title}
      download={download}
      onKeyDown={props.onKeyDown}
      target={type === "external" ? "_blank" : null}
      rel={type === "external" ? "noreferrer" : null}
      data-gtm-element={gtmElementLabel || "arrow link"}
      data-gtm-link={href}
      data-gtm-text={text}
      ref={focusRef}
    >
      {reversed && iconName && <Icon iconName={iconName} />}
      <span>{text}</span>
      {!reversed && iconName && <Icon iconName={iconName} />}
    </a>
  );
};
ArrowLink.propTypes = propTypes;
export { propTypes as arrowLinkPropTypes };
export default ArrowLink;
